import React from 'react';
import Link from 'next/link'; // Import Link from next/link
import styles from './Footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

const Footer = () => (
  <div className="themeVars"> {/* ✅ Inherit CSS variables */}
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <span className={styles.screenWidthIndicator}></span>

        <p className={styles.text}>
          &copy; 2025
          <Link href="https://shuffledb.com">
            <span className={styles.link}>ShuffleMaps.com</span> {/* Use span inside Link */}
          </Link> &mdash;{' '}
          Reach out to us for{' '}
          <a href="https://FlatIronsWebDev.com" className={styles.link} target="_blank" rel="noopener noreferrer">
            Web Development
          </a>{' '} |{' '}
          Rapidly implemented with{' '}
          <a href="https://equilibrium.technology/ap-AI" className={styles.link} target="_blank" rel="noopener noreferrer">
            ap-AI
          </a>{' '} by{' '}
          <a href="https://equilibrium.technology" className={styles.link} target="_blank" rel="noopener noreferrer">
            Equilibrium.Technology
          </a>, an AI business development agency.
        </p>

        <p className={styles.text}>
          Keep Dancing.
          <a
            href="https://instagram.com/altcapball"
            className={styles.instagramLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faInstagram} className={styles.igIcon} />
            @Altcapball
          </a>
        </p>
      </div>
    </footer>
  </div>
);

export default Footer;
